export const es = {
  loadListView: {
    header: {
      expectedShipDate: 'Fecha Estimada de Env\u00edo',
      supplier: 'Proveedor',
      loadNumber: 'Carga #',
      purchaseOrderNumber: 'OC #',
      bookingNumber: 'Reserva #',
      containerNumber: 'Contenedor #',
      releaseNumber: 'Liberaci\u00f3n #',
      numberOfMaterials: '# de Materiales',
      netWeight: 'Peso Neto',
      status: 'Estado',
      createdAt: 'Fecha de Creaci\u00f3n',
      actions: 'Acciones',
    },
  },
  bookingListView: {
    header: {
      bookingNumber: 'Reserva #',
      supplier: 'Proveedor',
      purchaseOrderNumber: '\u00d3rdenes de Compra',
      vesselArrivalDate: 'Fecha de Llegada del Buque',
      vesselName: 'Nombre del Buque',
      status: 'Estado',
      internalNotes: 'Notas Internas',
      actions: 'Acciones',
    },
  },
  purchaseOrderListView: {
    header: {
      createdOn: 'Creado el',
      supplier: 'Proveedor',
      poNumber: 'OC#',
      counterpartySoNumber: 'OV Contraparte#',
      numberOfMaterials: '# de Materiales',
      netWeight: 'Peso Neto',
      shippedLoads: 'Cargas Enviadas',
      fulfilledPercentage: '% Cumplido',
      status: 'Estado',
      totalAmount: 'Total',
      actions: 'Acciones',
    },
  },
  markLoadAsReceived: {
    loadReceivedOn: 'Carga recibida el',
    loadsReceivedOn: 'Cargas recibidas el',
    discard: 'Descartar',
    save: 'Guardar',
    markAsReceived: 'Marcar como Recibido',
  },
  markLoadAsReviewed: {
    loadReceivedOn: 'Carga recibida el',
    receivingTicketNumber: '# de Boleta de Recepción',
    receivedTicketIssueDate: 'Fecha de Emisión de Boleta',
    millReceivedWeightPostDate: 'Fecha de Publicación del Peso Recibido',
    discard: 'Descartar',
    markAsReviewed: 'Marcar como Revisado',
  },
  customerBillListView: {
    header: {
      supplierBillNumber: 'Proveedor / Factura #',
      total: 'Total',
      payDate: 'Fecha de Pago',
      accountManager: 'Gerente de Cuenta',
      actions: 'Acciones',
    },
  },
};
